<template>
  <v-navigation-drawer
    persistent
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    color="secondary"
  >
    <v-list dark>
      <!-- <v-list-item>
        <inline-svg
          class="mx-auto"
          :fill="$vuetify.theme.themes.light.white"
          width="200"
          :src="$images.FULL_LOGO"
        />
      </v-list-item> -->
      <template v-for="(item, i) in items">
        <template v-if="item.children">
          <v-list-group :key="i">
            <template v-slot:activator>
              <!-- <v-list-item-action>
                <v-icon color="secondary" v-html="item.icon"></v-icon>
              </v-list-item-action> -->
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <v-list-item
              value="true"
              v-for="(child, j) in item.children"
              :key="j"
              :to="child.link"
              class="pl-8"
              exact
            >
              <!-- <v-list-item-action>
                <v-icon
                  color="secondary"
                  v-html="child.icon"
                  v-if="child.icon"
                ></v-icon>
                <v-icon color="secondary" v-else
                  >$vuetify.icons.core_counts</v-icon
                >
              </v-list-item-action> -->
              <v-list-item-content>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item value="true" :to="item.link" :key="i">
            <!-- <v-list-item-action>
              <v-icon color="secondary" v-html="item.icon"></v-icon>
            </v-list-item-action> -->
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import * as mutationType from "@/store/mutation_types";
// import InlineSvg from "vue-inline-svg";
import { mapGetters } from "vuex";
export default {
  name: "LeftNavigation",

  components: {
    // "inline-svg": InlineSvg
  },

  data: () => ({
    clipped: true,
    miniVariant: false
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.getters["common/drawer"];
      },
      set(val) {
        this.$store.commit("common/" + mutationType.SET_DRAWER, val);
      }
    },
    items() {
      let items = [
        {
          title: this.settings.isPaidPlan ? "Dashboard" : "Getting Started",
          link: "/"
        }
      ];

      if (this.settings.isPaidPlan) {
        if (this.is_admin) {
          items.push({
            title: "Company",
            link: "/company",
            children: [
              {
                title: "Profile",
                link: "/company"
              },
              {
                title: "Members",
                link: "/company/members"
              },
              {
                title: "Departments",
                link: "/company/departments"
              }
            ]
          });
        }
        if (this.settings.planType != this.$enums.companyPlanTypes.LITE) {
          if (this.profile.isManager) {
            items.push({ title: "Team", link: "/team" });
          }
        }

        if (this.featureItems.filter(x => x.enabled && x.show).length > 0) {
          let features = this.featureItems.filter(x => x.show);

          if (this.is_admin) {
            features.push({
              title: "Manage Features",
              link: "/features",
              enabled: true,
              show: true,
              divider: true,
              icon: "settings",
              exact: true
            });
          }
          items.push({
            title: "Features",
            children: features
          });
        } else if (this.is_admin) {
          items.push({
            title: "Features",
            link: "/features"
          });
        }

        items.push({ title: "Reports", link: "/reporting" });
      } else if (this.is_admin) {
        items.push({ title: "Upgrade", link: "/billing" });
      }

      return items;
    },
    featureItems() {
      let baseItems = [];

      baseItems.push({
        title: "Culture Tracking",
        link: "/features/tracking",
        enabled: this.settings.isPulseActive,
        show: this.settings.isPulseActive
      });
      baseItems.push({
        title: "Surveys",
        link: "/features/surveys",
        enabled: this.settings.isSurveysActive,
        show: this.settings.isSurveysActive
      });
      baseItems.push({
        title: "Recognition",
        link: "/features/recognition",
        enabled: this.settings.isRecognitionActive,
        show: this.settings.isRecognitionActive
      });
      baseItems.push({
        title: "Training",
        link: "/features/training",
        enabled: this.settings.isResourcesActive,
        show: this.settings.isResourcesActive
      });

      baseItems.push({
        title: "360 Review",
        link: "/features/review",
        enabled: this.settings.isReviewActive,
        show: this.settings.isReviewActive
      });
      baseItems.push({
        title: "Meetings",
        link: "/features/meetings",
        enabled: this.settings.isCheckInActive,
        show: this.settings.isCheckInActive
      });
      baseItems.push({
        title: "Action Items",
        link: "/features/actionitems",
        enabled: this.settings.isCheckInActive,
        show: this.settings.isCheckInActive
      });
      baseItems.push({
        title: "Goals",
        link: "/features/goals",
        enabled: this.settings.isGoalsActive,
        show: this.settings.isGoalsActive
      });
      baseItems.push({
        title: "Annual Review",
        link: "/features/annual-reviews",
        enabled: this.settings.isAnnualReviewActive,
        show: this.settings.isAnnualReviewActive
      });

      return baseItems;
    },
    ...mapGetters({
      profile: "profile/profile",
      settings: "profile/settings",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager"
    })
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
